module.exports = __webpack_public_path__ + "img/06郑威.b24aa131.jpg";